import { CSSProperties } from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';

export function convertViewStyleToCss(style: StyleProp<ViewStyle>): CSSProperties {
  const flattened = StyleSheet.flatten(style);
  return { ...flattened, transform: undefined, aspectRatio: undefined } as CSSProperties;
}
